import { Callout, ICalloutProps } from '@fluentui/react/lib/Callout';

export interface IPCalloutProps extends ICalloutProps {}

export const IPCallout = (props: IPCalloutProps) => {
  return <Callout {...props}></Callout>;
};
